import { render } from "./upLoadFile.vue?vue&type=template&id=4939230c&scoped=true"
import script from "./upLoadFile.vue?vue&type=script&lang=js"
export * from "./upLoadFile.vue?vue&type=script&lang=js"

import "./upLoadFile.vue?vue&type=style&index=0&id=4939230c&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4939230c"]])

export default __exports__